import React from 'react';

import { useIntl } from 'react-intl';

import { MethodType } from './styled';

const ChequeGourmetMethod = () => {
  const { formatMessage } = useIntl();

  return <MethodType>{formatMessage({ id: 'payWithChequeGourmetVoucher' })}</MethodType>;
};

export default ChequeGourmetMethod;
